import React, { useState, useEffect } from "react";
import { opcionesAPI, type PuntoVenta } from "@/lib/api";
import { toast } from "sonner";
import { ListNewLoading, ListToolbar } from "@/components/ListNewButton";

interface Props {
  onEdit?: (item: PuntoVenta) => void;
  onNew?: () => void;
}

export function PuntoVentaListado({ onEdit, onNew }: Props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [puntosVenta, setPuntosVenta] = useState<PuntoVenta[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await opcionesAPI.listPuntosVenta();
        setPuntosVenta(data);
      } catch (error) {
        console.error("Error loading puntos venta:", error);
        toast.error("Error al cargar puntos de venta");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredPuntosVenta = puntosVenta.filter(pv =>
    !searchQuery ||
    pv.codigo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    pv.nombre?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (loading) {
    return <ListNewLoading onNew={onNew} message="Cargando puntos de venta..." />;
  }

  return (
    <div className="space-y-4 mt-4">
      <ListToolbar onNew={onNew}>
        <label className="block text-sm font-medium mb-1">Buscar</label>
        <input
          type="text"
          placeholder="Buscar por código o nombre..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full px-4 py-2 border border-input bg-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-sm"
        />
      </ListToolbar>

      {filteredPuntosVenta.length === 0 ? (
        <div className="p-8 text-center text-muted-foreground">
          No se encontraron puntos de venta
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted">
              <tr>
                <th className="px-4 py-2 text-left">Código</th>
                <th className="px-4 py-2 text-left">Nombre</th>
                <th className="px-4 py-2 text-left">Sucursal</th>
                <th className="px-4 py-2 text-left">ARCA Punto de Venta</th>
              </tr>
            </thead>
            <tbody>
              {filteredPuntosVenta.map((pv) => (
                <tr
                  key={pv.codigo}
                  className="border-b hover:bg-muted/50 cursor-pointer"
                  onClick={() => onEdit?.(pv)}
                >
                  <td className="px-4 py-2">{pv.codigo}</td>
                  <td className="px-4 py-2">{pv.nombre}</td>
                  <td className="px-4 py-2">{pv.sucursalNombre || '-'}</td>
                  <td className="px-4 py-2">{pv.afipPuntoVenta || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}